import { BaseProxy, type ProxyMethods } from '@/proxies/Proxy'

export default class FAQProxy extends BaseProxy implements ProxyMethods {
  public endpoint = 'faqs'
}
